import { useMutation } from "react-query";
import getLivenessPhotoVideo from "../services/getLivenessPhotoVideo";
function useGetLivenessPhotoVideo() {
  return useMutation(["get-liveness-photo-video"], getLivenessPhotoVideo);
}

export default useGetLivenessPhotoVideo;
